import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { PlusAlertsService } from 'components';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.css']
})
export class PublicComponent implements AfterViewInit {

  @ViewChild('publicDialogContainerRef', { read: ViewContainerRef }) publicDialogContainerRef: ViewContainerRef;

  constructor(private plusAlertService : PlusAlertsService) { }

  ngAfterViewInit(): void {
    this.plusAlertService.publicDialogContainerRef = this.publicDialogContainerRef;
  }

}